module.exports = __webpack_public_path__ + "img/slim08.006d11f5.jpg";